import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="View all available associations in the table. Use <strong>search</strong> and <strong>filters</strong> to find specific associations." id="view_all_available_associations_in_the_t.e6a2828e" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Browsing Associations" id="browsing_associations.9c1b80ba" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create Association</strong> to define a new grouping of content for a partner." id="click_create_association_to_define_a_new.fffcca23" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating an Association" id="creating_an_association.bed2d021" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Select an association to modify its contents, name, or configuration. Changes are saved when you confirm." id="select_an_association_to_modify_its_cont.875dfa5a" />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Editing an Association" id="editing_an_association.7c697338" />
        }
    ],
    title: <FormattedMessage defaultMessage="Associations" id="associations.a5026e86" />
};
